var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitedRoomMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0786 1.36522C12.3168 1.12475 12.6406 0.988368 12.9791 0.985875C13.3176 0.983381 13.6433 1.11498 13.8851 1.35191C14.1268 1.58885 14.265 1.91184 14.2693 2.25032C14.2736 2.58879 14.1438 2.91522 13.9082 3.15826L7.09078 11.6809C6.97366 11.807 6.83233 11.9082 6.67524 11.9784C6.51814 12.0487 6.34849 12.0866 6.17643 12.0898C6.00436 12.0931 5.83341 12.0616 5.67377 11.9973C5.51414 11.933 5.36909 11.8372 5.2473 11.7157L0.727301 7.19739C0.487107 6.95708 0.352213 6.6312 0.352295 6.29143C0.352376 5.95167 0.487427 5.62585 0.727736 5.38565C0.968045 5.14546 1.29393 5.01057 1.6337 5.01065C1.97346 5.01073 2.29928 5.14578 2.53947 5.38609L6.11426 8.96174L12.0447 1.40522C12.0555 1.39147 12.0671 1.3784 12.0795 1.36609L12.0786 1.36522Z",
    fill: "#00CE84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitedRoomMark);
export default __webpack_public_path__ + "static/media/visited_room_mark.401d5b54b7e27e454761435c937712a2.svg";
export { ForwardRef as ReactComponent };